import React, { FC } from 'react';
import { TopPerformingBrokers } from './components/TopPerformingBrokers';
import SummaryCard from './components/SummaryCard';
import ActiveLeadsCard from './components/ActiveLeadsCard';
import DealByStatusCard from './components/DealByStatusCard';
import EnterpriseNavigation from '../../components/EnterpriseNavigation';

import './Analytics.styles.scss';
import './Analytics.styles.responsive.scss';

const Analytics: FC = () => {
  return (
    <div className="enterprise-analytics">
      <EnterpriseNavigation />

      <div className="enterprise-analytics__cards">
        <SummaryCard />
        <TopPerformingBrokers />
        <DealByStatusCard />
        <ActiveLeadsCard />
      </div>
    </div>
  );
};

export default Analytics;
